var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ed1521ac-64bc-467e-9a78-316a56defee7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c099b78c-5fdc-465a-bc04-197ffd32e49e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "026ead0d-3c55-4ac4-afdc-9b3e5a59655f"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(7,168,137)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-224, -256)",
    d: "M 304 128 C 304 83.81722001353653 268.18277998646346 48 224 48 C 179.81722001353654 48 144 83.81722001353651 144 127.99999999999999 C 144 172.18277998646346 179.81722001353654 208 224 208 C 268.18277998646346 208 304 172.18277998646346 304 128 z M 96 128 C 96 57.30755202165844 153.30755202165844 0 224 0 C 294.69244797834153 0 352 57.30755202165841 352 127.99999999999997 C 352 198.69244797834156 294.69244797834153 256 224 256 C 153.30755202165844 256 96 198.69244797834156 96 128 z M 49.3 464 L 398.7 464 C 389.8 400.7 335.4 352 269.7 352 L 178.3 352 C 112.60000000000001 352 58.20000000000002 400.7 49.30000000000001 464 z M 0 482.3 C 0 383.8 79.8 304 178.3 304 L 269.70000000000005 304 C 368.2 304 448 383.8 448 482.3 C 448 498.7 434.7 512 418.3 512 L 29.7 512 C 13.3 512 0 498.7 0 482.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.db880069f0f50d19049fe50297eec3d9.svg";
export { ForwardRef as ReactComponent };